export default [
  {
    url: "/admin",
    name: "الرئيسية",
    slug: "Home",
    icon: "HomeIcon",
  },
  {
    url: "/admin/students",
    name: "الطلبة",
    slug: "students",
    icon: "UserIcon",
    role: ['view_students']
  },
  {
    url: "/admin/teachers",
    name: "أعضاء هيئة التدريس",
    slug: "teachers",
    icon: "UserIcon",
    role: ["view_teachers"]
  },
  {
    url: "/admin/courses",
    name: "المواد الدراسية",
    slug: "courses",
    icon: "BookIcon",
    role: ["view_courses"]
  },
  {
    url: "/admin/user_roles",
    name: "الصلاحيات",
    slug: "roles",
    icon: "LockIcon",
    role: ["view_roles"]
  },
  {
    url: "/admin/terms",
    name: "الفصول الدراسية",
    slug: "terms",
    icon: "BookmarkIcon",
    role: ["view_terms"]
  },

]
